import { render, staticRenderFns } from "./TableEdit.vue?vue&type=template&id=078a56a0&scoped=true&"
import script from "./TableEdit.vue?vue&type=script&lang=js&"
export * from "./TableEdit.vue?vue&type=script&lang=js&"
import style0 from "./TableEdit.vue?vue&type=style&index=0&id=078a56a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078a56a0",
  null
  
)

export default component.exports